import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";
import {getFeatureGroupName} from "../../../../../misc/helpers";


const LookCompatabilitySectionContent = (props) => {

  const {lookCompatabilityAlert, intl, fabricatorData} = props;
  const {compatabilityLogic} = lookCompatabilityAlert;

  if (!compatabilityLogic) {
    return null
  }

  return (
    <div className="lk-comp">
      <div className="lk-comp__item">
        <div className="lk-comp__item-cell lk-comp__item-cell--th">
          <FormattedMessage id="buttons.from"/>
        </div>
        <div className="lk-comp__item-cell lk-comp__item-cell--th"/>
        <div className="lk-comp__item-cell lk-comp__item-cell--th">
          <FormattedMessage id="buttons.to"/>
        </div>
      </div>
      <ul className="lk-comp__list">
        {compatabilityLogic.map((compatabilityObject, compatabilityObjectIndex) => {
          const fromFeature = compatabilityObject.from;
          const toFeature = compatabilityObject.to;
          const key = fromFeature
            ? fromFeature.dbFeature.id
            : toFeature ? toFeature.dbFeature.id : "comp" + compatabilityObjectIndex;

          return (
            <li className="lk-comp__item" key={key}>
              <div className="lk-comp__item-cell">
                {fromFeature ? (
                  <FeatureThumbnail feature={fromFeature}
                                    lookActiveCategory={fromFeature.partId}
                                    dbFeatureId={fromFeature.dbFeature.id}/>
                ) : <div className="feature-thumbnail lk-comp__thumbnail lk-comp__thumbnail--empty"/>}
              </div>
              <div className="lk-comp__item-cell">
              <span className="lk-comp__arrow">
                {getFeatureGroupName((fromFeature || toFeature).getParent(), intl, fabricatorData)}
              </span>
              </div>
              <div className="lk-comp__item-cell">
                {toFeature ? (
                  <FeatureThumbnail feature={toFeature}
                                    lookActiveCategory={toFeature.partId}
                                    dbFeatureId={toFeature.dbFeature.id}/>
                ) : <div className="feature-thumbnail lk-comp__thumbnail lk-comp__thumbnail--empty"/>}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookCompatabilityAlert, lookActiveFeature} = store.lookState;
  const fabricatorData = store.fabricatorState;
  return {
    lookActiveFeature,
    lookCompatabilityAlert,
    fabricatorData,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookCompatabilitySectionContent)
);
